import React from 'react';
// import Modal from 'react-responsive-modal';
import { Modal } from '@vds/modals';
import * as action from './../action/modalWindow'
import { updateSCTags, tempSCData, updateSCcustomEvent } from './../service/dtmTag';
import * as ChannelBackend from '../action/channelLineup';
import { ModalWindow, Pages } from './../constants/actionType';
import * as pfbAutopayAction from './../action/PFBAutopay';
import * as checkoutAction from './../action/checkout';
import { redirectTo } from './../action/redirection';
//import * as modalAction from './../action/modalWindow';
import { InHomeUtils } from './../util/inhomeUtils'
import { tempVzdlSCData, updateVzdlSCCustomEvent,vzdlErrorUpdate } from '../service/vzdl';

class modalOverlay extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state={
            activateFocusTrap: false,
            isWhwFaq:false
        }
        this.modalRef = React.createRef();
        // const modalId = this.props.modalWindow.modalId;
        // if (modalId) {
        //     modalAction.closeModalWindow(modalId, props.dispatch);
        // }
        //focus trap
        this.firstChildEl;
        this.lastChildEl;
        this.mutObserver;
    }

    componentDidMount(){
        this.setState({activateFocusTrap: true})
        

    }

    fallbackFocus= () => {
        console.log('fallbackFocus');
        return document.querySelector('#modal-container');
    }

    onCloseModal = (e) => {
        // e.preventDefault();
        if(this.props.modalWindow.modalId === ModalWindow.ids.yourCart || this.props.modalWindow.modalId === ModalWindow.ids.currentCart){
            this.props.closeCart()
        }
        if(this.props.modalWindow.modalId === ModalWindow.ids.saveEc) {
            updateSCTags("close")
            vzdl.page.name = window.location.pathname?.includes("buildproducts") ? "Service Overview" : "checkout"
        }
        if (this.props.serviceType === 'CUSTOMTV' || this.props.serviceType === 'TV' || this.props.modalOverlayId === 'helptv-modal-overlay') {
            ChannelBackend.clearChannelResults(this.props.dispatch);
            ChannelBackend.displayCLUMaster(this.props.dispatch);
            ChannelBackend.clearSelectedPkgs(this.props.dispatch);
            ChannelBackend.clearSelectedChannels(this.props.dispatch);
        }        
        if (this.props.modalWindow.modalId === ModalWindow.ids.PFBContinueTos) {
            pfbAutopayAction.pfbTosAgree("PFBVIEW", this.props.dispatch);
            tempSCData.detailPageName = "ec| services overview| info and credit - pfb| primary email address| tos error";
            // tempVzdlSCData.detail = "info and credit - pfb primary email address tos error"; 
            updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "detailPageName");
            // updateVzdlSCCustomEvent("pfbandAutoPayLoad", "pageViewOmni", "detail");
            vzdlErrorUpdate("","Terms of service must be accepted to proceed with current selection.", "event11,prodView");
        }
        if (this.props.modalWindow.modalId === ModalWindow.ids.AUTOPAYContinueTos) {
            pfbAutopayAction.autopayTosAgree("AUTOPAYTOSVIEW", this.props.dispatch);
            let paymentMode = InHomeUtils.isNotNull(this.props.paymentMode) && this.props.paymentMode !== '' ? this.props.paymentMode.toLowerCase() : '';
            tempSCData.detailPageName = "ec| services overview| info and credit - autopay| payment - " + paymentMode + "| tos error";
            // tempVzdlSCData.detail = "info and credit - autopay payment - " + paymentMode + " tos error";
            updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "detailPageName");
            // updateVzdlSCCustomEvent("pfbandAutoPayLoad", "pageViewOmni", "detail");
            vzdlErrorUpdate("","Auto pay terms of service must be accepted to proceed with current selection.", "event11,prodView");
        }
        if (this.props.modalWindow.modalId === ModalWindow.ids.AUTOPAYPFBTos) {
            pfbAutopayAction.autopayTosAgree("AUTOPAYTOSVIEW", this.props.dispatch);
            let paymentMode = InHomeUtils.isNotNull(this.props.paymentMode) && this.props.paymentMode !== '' ? this.props.paymentMode.toLowerCase() : '';
            //tempSCData.detailPageName = "ec| services overview| info and credit - autopay| payment - " + paymentMode + "| tos error";
            updateSCTags("close sign", '', `${this.props.tagDetailValue} - terms & conditions`);
            
            //updateSCcustomEvent("pfbandAutoPayLoad", "ddCheckoutEvent", "detailPageName");
            // updateVzdlSCCustomEvent("pfbandAutoPayLoad", "pageViewOmni", "detail");
            setTimeout(() => {
                tempVzdlSCData.detail = "Your Billing preferences";
                updateVzdlSCCustomEvent("pfbandAutoPayLoadReskin","pageViewOmni","detail") 
            }, 2000);
            // vzdlErrorUpdate("","Auto pay terms of service must be accepted to proceed with current selection.", "event11,prodView");
            
        }
        if (this.props.serviceType === "ROUTER" || this.props.serviceType === "CUSTOMROUTER"){
            if(this.props.modalPrdDetails && this.props.modalPrdDetails.name && this.props.modalPrdDetails.name !== undefined)
            updateSCTags("close " + this.props.modalPrdDetails.name.toLowerCase() + " overlay");
        }
        if (this.props.serviceType === "INTERNET" &&  this.props.modalWindow.modalId.indexOf("DETAIL") > -1){
            updateSCTags("close " + this.props.modalPrdDetails.name.toLowerCase() + " overlay");
        }
        if (this.props.modalWindow.modalId === ModalWindow.ids.tosview) { 
            console.log(this.props.onTosChange);
            if (InHomeUtils.isNotNull(this.props.onTosChange) && this.props.onTosChange === true) {
                if (InHomeUtils.isNotNull(this.props.isVoiceInCart) && this.props.isVoiceInCart === true) {
                    // voice avialable in cart
                    if (InHomeUtils.isNotNull(this.props.onTosVoiceChange) && this.props.onTosVoiceChange === true) {
                        checkoutAction.updateTOSAccordion('change', this.props.dispatch);
                    }
                
                    if (InHomeUtils.isNotNull(this.props.onTosVoiceChange) && this.props.onTosVoiceChange === false) {
                        checkoutAction.updateTOSAccordion('required', this.props.dispatch);
                    }
                    
                } else if (InHomeUtils.isNotNull(this.props.isVoiceInCart) && this.props.isVoiceInCart === false) {
                    // no voice
                    checkoutAction.updateTOSAccordion('change', this.props.dispatch);
                }
            }
        }
        if (this.props.modalWindow.modalId === ModalWindow.ids.tos) {
            if(InHomeUtils.isNotNull(this.props.enableTermsInteractions) && this.props.enableTermsInteractions === true)
            {
               this.props.onCloseTosModal();
            }
        }
        
        if (this.props.modalWindow.modalId === ModalWindow.ids.upsell || this.props.modalWindow.modalId === ModalWindow.ids.URCPerksOverlay) {
            this.props.noThanks();
        }

        if (this.props.modalWindow.modalId === ModalWindow.ids.coupon) {           
            this.props.exitCouponModal();
        }
        let connectionProofStatus = InHomeUtils.isNotNull(this.props.connectionProofStatus) && this.props.connectionProofStatus !== '' ? this.props.connectionProofStatus : '';
        if (this.props.modalWindow.modalId === ModalWindow.ids.uploadProof && connectionProofStatus === "SUCCESS") {
            redirectTo(Pages.EmployeeConfirmation + "&fromflow=uploadproof", this.props.dispatch)
        }

        // for iOS devcies, enable momentum scrolling if disabled
        const bodyClassList = window?.document?.body?.classList;
        if (bodyClassList.contains('device-ios') && bodyClassList.contains('disable-momentum-scrolling')) {
            bodyClassList.remove('disable-momentum-scrolling');
        }
        
        action?.closeModalWindow(this?.props?.modalWindow?.modalId, this?.props?.dispatch, 'linkCall', true, false);
    };

    //focus trap
    onFirstChildElKeydown = (e) => {        
        if (e.keyCode === 9 && e.shiftKey) {            
            this.lastChildEl && this.lastChildEl.focus();
            // e.preventDefault();
            //console.log("First el keydown FOCUSING on Last ", this.lastChildEl);
        }       
    }

    onLastChildElKeydown = (e) => {        
        if (e.keyCode === 9 && !e.shiftKey) {            
            this.firstChildEl && this.firstChildEl.focus();
            // e.preventDefault();
            //console.log("Last el keydown FOCUSING on first ", this.firstChildEl);
        }               
    }
    
    getFocusTrapSentEl() {
        let firstLastFocEl = [undefined, undefined];
        let childElements = [...this.modalRef.current.querySelectorAll('*')];
        if (childElements && childElements.length) {
            //console.log("ALL CHILDREN ", childElements);
            let focEl = [];
            childElements.forEach((el) => {
                (el.getAttribute('tabindex') === '0' || (!el.disabled && (el.tagName.toLowerCase() === 'button' || el.tagName.toLowerCase() === 'input'))) && focEl.push(el);
            });
            
            firstLastFocEl = focEl.length ? [focEl[0], focEl[focEl.length - 1]] : firstLastFocEl;            
        }

        return firstLastFocEl;        
    }

    onMutation = () => {
        //console.log("Observer callback");
        //focus trap
        let [firstChildEl, lastChildEl] = this.getFocusTrapSentEl();    
        if (firstChildEl && (!this.firstChildEl || !firstChildEl.onkeydown)) {
            this.firstChildEl ? this.firstChildEl.onkeydown = null : '';
            this.firstChildEl = firstChildEl;
            this.firstChildEl.onkeydown = this.onFirstChildElKeydown;
        }
        if (lastChildEl && (!this.lastChildEl || !lastChildEl.onkeydown)) {
            setTimeout(() => {
                this.lastChildEl ? this.lastChildEl.onkeydown = null : ''
                this.lastChildEl = lastChildEl;
                if (!this.lastChildEl.classList.contains("sc-kgoBCf")) {
                    this.lastChildEl.onkeydown = this.onLastChildElKeydown;
                }
            })
        }        
    }
    
    handleModalToggle=(isOpen)=>{
        if(!isOpen){
            this?.props?.onCloseModal ? this?.props?.onCloseModal() : this?.onCloseModal()
        }
        // PRODDEF-18194 issue 13 Place Order Button Focus issue
        if(!isOpen && this?.props?.modalWindow?.modalId === 'TOS'){
            setTimeout(()=>{
                let focusingElem = document?.getElementById('Place_Order');
                if(focusingElem){
                    focusingElem?.focus()
                    return;
                }
        },2000)
        }
    }

    componentDidUpdate(prevProps) {
        // This code is for to remove the muliple portal loading while opening Modal
        if(this?.props?.modalWindow?.isModalOpened !== prevProps?.modalWindow?.isModalOpened){
            setTimeout(()=>{
            const  portals = document.querySelectorAll("#portal");
            // const lastPortal = portals[portals.length -1];
            for(let i = 0; i < portals?.length - 1; i++) {
                portals[i].remove()
            }
            },0)
        }

        var ele = document?.getElementsByClassName('styles_closeButton__20ID4');
        if (ele && ele.length) {
            let closeIcon = ele[0];
            if (!closeIcon.hasAttribute('aria-label')) {
                closeIcon.setAttribute('aria-label', 'Click here or press escape key to close the modal');
                let wrapper = closeIcon.parentNode
                let items = [...wrapper.childNodes]
                wrapper.appendChild(closeIcon)
                items.forEach(item => {
                    if (items.indexOf(item) !== items.length - 1) {
                        wrapper.appendChild(item)
                    }
                })
                closeIcon.focus();
            }
            if (!document.body.classList.contains('modal-open')) {
                document.body.classList.add('modal-open');
            }
        } else {
            document.body.classList.contains('modal-open') && document.body.classList.remove('modal-open');
        }

        if (this.modalRef.current && this.modalRef.current.childNodes) {
            //add accessibility attributes for modal            
            if (this.props.template && this.props.modalOverlayId && this.props.modalOverlayId === 'clu-modal-overlay') {
                this.modalRef.current.setAttribute('aria-label', this.props.modalPrdDetails.name);
            } else {
                let modalWrapperEl = this.modalRef.current;
                let modalTitleEl = modalWrapperEl.querySelector('.modal_header h5') || modalWrapperEl.querySelector('.title h3');
                if (!modalTitleEl) {
                    // modal could be using SideBanner component
                    modalTitleEl = modalWrapperEl.querySelector('#side-banner-text');
                }
                modalTitleEl && this.modalRef.current.setAttribute('aria-label', modalTitleEl.innerHTML);
            }

            //observer
            if (!this.mutObserver && this.modalRef.current) {
                this.mutObserver = new MutationObserver(this.onMutation);
                this.mutObserver.observe(this.modalRef.current, { attributes: true, childList: true, subtree: true });
            }
        }
    }

    componentWillUnmount() {
        this.mutObserver && this.mutObserver.disconnect();
        
    }

    render() {
        const open = this.props.modalWindow.isModalOpened;
        let content = this.props.template;
        let inCreasedWidthModals = ["COMPAREVASIP","ADDPREMIUMHELPER"]
        
        if (content) {
            if (this.props.modalWindow.modalId === "BANNER") {
                if (this.props.showStadia) {
                    updateSCTags("banner - int stadia offer learn more")
                }
                else if(InHomeUtils.isNotNull(this.props.holidaySCLink)) {
                    updateSCTags(this.props.holidaySCLink);
                }
                else{
                    updateSCTags("learn more")
                }
            }
         else if (this.props.modalWindow.modalId === "FOOTER_LEARN"){
            updateSCTags("h-m learn more")
         }
        }
        let hideCloseButton = false;
        let closeButtonClasName = "closeModalCustomBtn";
        if(this.props.modalWindow.modalId === ModalWindow.ids.connectedAppsConfirm) {
            hideCloseButton = true;
        }

        if(this.props.modalWindow.modalId === ModalWindow.ids.connectedAppsVroom){
            closeButtonClasName = "closeModalCustomBtnNew"
        }
        //onClose={this.props.onCloseModal ? this.props.onCloseModal : this.onCloseModal}
        // const clsbtn = <div className="closeModalCustomBtn" autoFocus={true} tabIndex='0' onClick={this.props.onCloseModal ? this.props.onCloseModal : this.onCloseModal} onKeyDown={this.props.onCloseModal ? this.props.onCloseModal : this.onCloseModal} title="Close"></div>;


        // const clsbtn = <a href="javascript:void(0)" className={closeButtonClasName} autoFocus={true} tabIndex='0' onClick={this.props.onCloseModal ? this.props.onCloseModal : this.onCloseModal} onKeyPress={this.props.onCloseModal ? this.props.onCloseModal : this.onCloseModal} title="Close" role="button" aria-label="Click here or press escape key to close the modal"></a>;
        let modalContent = null;
        /**<Modal open={open} onClose={this.props.onCloseModal? this.props.onCloseModal : this.onCloseModal}  modalId={this.props.modalWindow.modalId} center  blockScroll
                focusTrapped={this.state.activateFocusTrap} focusTrapOptions={{ fallbackFocus: this.fallbackFocus }} overlayId={this.props.modalOverlayId} container={this.modalRef.current}>{content}</Modal> */
        let closeButtonFlag = undefined;
        if(this.props.modalWindow && this.props.modalWindow.modalId && this.props.modalWindow.modalId=='mnhPushNotificationOverlay'){
            closeButtonFlag = null;
        }
        if (content !== '' && content !== undefined)
            modalContent = <Modal fullScreenDialog={sessionStorage.getItem("hostedAttractLoop") === "true" && sessionStorage?.getItem('fiosReferralFlow') === "true"} id={this?.props?.id} onOpenedChange={(isOpen)=>this?.handleModalToggle(isOpen)} className={inCreasedWidthModals?.includes(this?.props?.modalWindow?.modalId)?`EcIncreasedWidthModals${this?.props?.modalWindow?.modalId}`:""} opened={open} disableOutsideClick={true} customScroll={false} modalId={this?.props?.modalWindow?.modalId} center  blockScroll 
                focusTrapped={this?.state?.activateFocusTrap} focusTrapOptions={{ fallbackFocus: this?.fallbackFocus }} overlayId={this?.props?.modalOverlayId} container={this?.modalRef?.current} hideCloseButton={hideCloseButton} closeButton = {closeButtonFlag}>{content}</Modal>
                return (
            <div ref={this?.modalRef} role="dialog" aria-modal="true" id="modal-container" tabIndex="-1" aria-hidden={modalContent ? "false" : "true"} style={{display: modalContent ? "block" : "none"}}>
                {modalContent}
            </div>
        );
    }
}

// const mapStateToProps = (state) => {
//     return {
//         paymentModeSelection: state.pfbautopay.paymentmodeSelection,
//         connectionProofStatus: state.connection.proofUpload,
//     }
// }

// export default withCookies(connect(
//     mapStateToProps
// )(modalOverlay));

export default modalOverlay;
